import AsyncStorage from "@react-native-async-storage/async-storage"
import { Alert, Platform, Settings } from "react-native";
import { EventRegister } from "react-native-event-listeners";
import DataController from "./DataController";
import RNFS from 'react-native-fs';

const AuthenticationController = {
  serverURL() {
    // return 'http://localhost:8013';
//     return 'https://cofe.aimernginx.co.uk';
    return 'https://hymns-api.hymnsam.co.uk';
  },

  async login(email: String, password: String) {
    EventRegister.emit('auth/signing-in', true);

    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/login`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(password && { Password: password }),
        };

        __DEV__ && console.log(body);

        /**
        * Example response
        *
        *  {
               "ResponseMessage": "Success",
               "Token": "••••••••••••",
               "ErrorMessage": "All OK"
           }
        */

        response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        const responseJson = await response.json();
        const responseBody = responseJson.body;

        if (responseBody.ResponseMessage === 'Success' && responseBody.Token !== null) {
          try {
            let user = {
              email: email,
              token: responseBody.Token,
              requestToken: responseBody.requestToken,
            };

            resolve(user);
          } catch (error) {
            console.log('error saving user: ' + error);
            EventRegister.emit('auth/signing-in', false);
            reject(error);
          }
        } else {
          console.log('error saving user: ' + responseBody.ErrorMessage);
          EventRegister.emit('auth/signing-in', false);
          reject(responseBody.ErrorMessage);
        }
      } catch (error) {
        console.log('error saving user: ' + error);
        EventRegister.emit('auth/signing-in', false);
        reject(error);
      }
    });
  },

  async generateToken(email: String, token: String) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/generateToken`
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(token && { Token: token }),
        };

        /**
      * Example response
          {
          "success": true,
            "message": "/lectionary/generateToken => User logged in",
              "body": {
            "requestToken": "TOKEN"
          }
        }
      */
        response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        let responseJson;

        try {
          responseJson = await response.json();
        } catch (error) {
          console.log('getSubscription json error', error);
        }

        const responseBody = responseJson.body;

        if (responseJson.success) {
          resolve(responseBody.requestToken);
        } else {
          reject(responseBody);
        }
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  async getSubscriptions(email: String, token: String, requestToken: String) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/getSubscriptions`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(token && { Token: token }),
          ...(requestToken && { RequestToken: requestToken }),
        };

        /**
        * Example response
            {
              "ResponseMessage": "Success",
              "Subscriptions": [
                  {
                      "Title": "Lectionary",
                      "PublicationId": 21,
                      "SubscriptionCreatedById": 0,
                      "SubscriptionId": ID,
                      "StartDate": "2020-09-17T00:00:00",
                      "ExpiryDate": "2025-09-17T00:00:00",
                      "Status": 1,
                      "AdditionalAppData": "NOSET"
                  }
              ]
          }

          {
            "ResponseMessage": "Success",
              "Subscriptions": []
          }
        */

        response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        let responseJson;

        try {
          responseJson = await response.json();
        } catch (error) {
          console.log('getSubscription json error', error);
        }

        const responseBody = responseJson.body;

        // console.log('responseBody', responseJson);

        if (responseBody.ResponseMessage === 'Success') {
          try {
            let subs = [];

            if (responseBody.Subscriptions && responseBody.Subscriptions.length > 0) {
              subs = responseBody.Subscriptions.filter((_subs) => _subs.PublicationId === 21);
            }

            resolve(responseBody.Subscriptions);
          } catch (error) {
            console.log('error saving subscription info: ' + error);
            reject(error);
          }
        } else {
          /*   {
              "ResponseMessage": "User not found",
                "Subscriptions": null
            } */
          reject(responseBody);
        }
      } catch (error) {
        console.log('getSubscriptions', error);
        reject(error);
      }
    });
  },

  async saveUser(user) {
    try {
      await AsyncStorage.setItem('user', JSON.stringify(user));
    } catch (error) {
      console.log(error);
    }
  },

  async logout() {
    await AsyncStorage.removeItem('user');
    await AsyncStorage.removeItem('hymnsSubscription');

    if (Platform.OS === 'web') {
      await AsyncStorage.removeItem('notes');
      await AsyncStorage.removeItem('bookmarks');
      await AsyncStorage.removeItem('collectType');
      await AsyncStorage.removeItem('fontMultiplier');
      await AsyncStorage.removeItem('SWChurchInformation');
      await AsyncStorage.removeItem('appOpenBehaviour');
      await AsyncStorage.removeItem('recentlyViewed');
      await AsyncStorage.removeItem('serviceType');
    }
  },

  async getUser() {
    try {
      const user = await AsyncStorage.getItem('user');

      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.log(error);
    }
  },

  async setWelcomeOpened() {
    try {
      await AsyncStorage.setItem('welcomeOpened', 'true');
    } catch (error) {
      console.log(error);
    }
  },

  async getWelcomeOpened() {
    try {
      const opened = await AsyncStorage.getItem('welcomeOpened');

      return opened === 'true';
    } catch (error) {
      console.log(error);
    }
  },

  async saveFreeTrialData(data) {
    try {
      await AsyncStorage.setItem('trialData', JSON.stringify(data));
    } catch (error) {
      console.log(error);
    }
  },

  async getFreeTrialData() {
    try {
      const data = await AsyncStorage.getItem('trialData');

      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.log(error);

      return null;
    }
  },

  async checkIfUpgradingFromV1() {
    try {
      const upgraded = await AsyncStorage.getItem('upgradedToV2');

      if (upgraded !== 'true') {
        let hymnsToken;
        let hymnsEmail;

        if (Platform.OS === 'ios') {
          hymnsToken = Settings.get('hymnsToken');
          hymnsEmail = Settings.get('hymnsEmail');
        } else if (Platform.OS === 'android') {
          const keys = await AsyncStorage.getAllKeys();
          __DEV__ && console.log('ASYNC STORAGE KEYS', keys);

          ///data/data/com.aimer.lectionary/app_webview/Default/Local Storage/leveldb
          // const files = await RNFS.readDir(encodeURI('/data/user/0/com.aimer.lectionary/app_webview/Default/Local Storage'));

          // console.log('RNFS FILES', files);

          hymnsToken = await AsyncStorage.getItem('com.aimer.lectionary.HymnsToken');
          hymnsEmail = await AsyncStorage.getItem('com.aimer.lectionary.HymnsEmail');
        }

        if (hymnsToken && hymnsEmail) {
          let token = await this.generateToken(hymnsEmail, hymnsToken);

          if (token) {
            let user = {
              email: hymnsEmail,
              token: hymnsToken,
              requestToken: token,
            };

            let subscriptions = await AuthenticationController.getSubscriptions(user.email, user.token, user.requestToken);

            if (subscriptions) {
              subscriptions = subscriptions.filter((item) => item.Status === 1);
              subscriptions = subscriptions.sort((a, b) => new Date(b.ExpiryDate) - new Date(a.ExpiryDate));
              DataController.saveHymnsSubscription(subscriptions);
            }

            await this.saveUser(user);
            await AsyncStorage.setItem('upgradedToV2', 'true');
            EventRegister.emit('auth/user-changed', user);
            return true;
          }
        }
      }

      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  },
};

export default AuthenticationController;
